'use client';

import type { IconsWithTextType } from '@eliadmin/core/src/api/general/types/general-types';

import { Carousel } from '../ui/carousel';
import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { ServiceIconCard } from './service-icon-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ServiceIconsCarousel({ icons }: { icons: IconsWithTextType[] }) {
  const carouselContext = useCarouselContext();

  if (!carouselContext) {
    throw new Error('Hero must be used within a CarouselProvider');
  }

  const { selectedIndex, slideCount } = carouselContext;

  const options = {
    loop: false,
    align: 'start' as const,
  };

  const progress = ((selectedIndex + 1) / slideCount) * 100;

  return (
    <div className="flex w-full flex-col items-start justify-start gap-8 sm:gap-10 md:hidden">
      <Carousel
        options={options}
        className={{
          main: 'w-full',
          container: 'w-full gap-4 sm:gap-5',
          wrapper: 'w-full',
          slide: 'w-full max-w-[240px] sm:max-w-[280px]',
        }}
        slides={icons.map(icon => (
          <ServiceIconCard icon={icon} key={icon.id} />
        ))}
      />
      <div className="w-full pr-4">
        <div className="flex h-[2px] w-full items-center justify-start bg-black/10">
          <div
            className={cn(
              'h-1 bg-black transition-all duration-300',
              'ea-team-members__carousel-progress-bar-indicator',
            )}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
